/**
 * Order Configuration
 *
 * Per-channel order rules. Values are in channel-native currency
 * (EUR for `eu`, USD for `us`). Comparisons against `subtotalPrice`
 * always happen in channel currency, never in display currency.
 */

export const ORDER_CONFIG = {
	minimumOrderValue: {
		eu: 50,
		us: 50,
	},
} as const;
